import { apiBase } from '@/api/instance';
import Qs from 'qs';

export const SearchColor = (params) => {
  return apiBase({
    url: `/cats/colors`,
    method: 'get',
    params: params,
    paramsSerializer: (params) => {
      return Qs.stringify(params, { arrayFormat: 'repeat' });
    }
  });
};

export const StoreColor = (params) => {
  return apiBase({
    url: '/cats/colors',
    method: 'post',
    data: params
  });
};

export const ShowColor = ({ id }) => {
  return apiBase({
    url: `/cats/colors/${id}`,
    method: 'get'
  });
};

export const UpdateColor = (params) => {
  return apiBase({
    url: `/cats/colors/${params.id}`,
    method: 'put',
    data: params
  });
};

export const DestroyColor = ({ id }) => {
  return apiBase({
    url: `/cats/colors/${id}`,
    method: 'delete'
  });
};
